import { createIcon } from '../createIcon.tsx';

export const DocumentTextIcon = createIcon(
	'DocumentTextIcon',
	<>
		<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" />
		<path d="M14 2v6h6" />
		<path d="M16 13H8" />
		<path d="M16 17H8" />
		<path d="M10 9H8" />
	</>,
);
